import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { noop } from 'utils/func';

import FieldLabel from '../FieldLabel/FieldLabel';
import FieldMessages from '../FieldMessages/FieldMessages';

export default class Select extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    id: PropTypes.string,
    infoMessage: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onValidate: PropTypes.func,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
      })
    ),
    registerField: PropTypes.func,
    required: PropTypes.bool,
    shouldRunValidators: PropTypes.bool,
    validators: PropTypes.array,
    value: PropTypes.string,
    small: PropTypes.bool,
  };

  static defaultProps = {
    options: [],
    validators: [],
  };

  constructor(props) {
    super(props);
    this.runValidators = this.runValidators.bind(this);
  }

  componentDidMount = () => {
    const { registerField, name, value } = this.props;
    if (registerField) {
      const firstOption = this.inputField.options[0];
      registerField(name, value || (firstOption && firstOption.value));
    }
  }

  componentDidUpdate = (prevProps) => {
    if (!prevProps.shouldRunValidators && this.props.shouldRunValidators) {
      this.runValidators(this.inputField.options[this.inputField.selectedIndex]);
    }
  }

  handleChange = (ev) => {
    const { value } = ev.target;

    if (this.props.onChange) {
      this.props.onChange(this.props.name, value);
    }

    this.runValidators(value);
  };

  attachValidators = noop;

  runValidators(value) {
    const errorMessage = this.validateField();
    const isValid = !errorMessage;
    if (this.props.onValidate) {
      this.props.onValidate(this.props.name, {
        errorMessage,
        isValid,
        value,
      });
    }
  }

  validateField() {
    const { validators } = this.props;
    for (const validator of validators) {
      const { value } = this.inputField.options[this.inputField.selectedIndex];
      const isValid = validator.validator(value, validator.options);
      if (!isValid) {
        return validator.message;
      }
    }
    return null;
  }

  render() {
    const {
      className,
      disabled,
      errorMessage,
      id,
      infoMessage,
      label,
      name,
      options,
      required,
      value,
      small,
    } = this.props;

    const uniqueId = id || name;
    const errorDescribedBy = `qr-${uniqueId}-error`;

    return (
      <div className="gn-select">
        <FieldLabel
          disabled={disabled}
          htmlFor={uniqueId}
          label={label}
          required={required}
        />

        <select
          id={uniqueId}
          name={name}
          ref={(inputField) => { this.inputField = inputField; }}
          onChange={this.handleChange}
          aria-describedby={errorMessage ? errorDescribedBy : null}
          aria-invalid={!errorMessage}
          aria-required={required}
          disabled={disabled}
          value={value}
          className={classNames(
            'gn-select__field',
            className,
            {
              'gn-select__field--invalid': !!errorMessage,
              'gn-select__field--small': !!small,
            }
          )}
        >
          {options.map((option, index) =>
            // eslint-disable-next-line react/no-array-index-key
            <option key={index} value={option.value} disabled={option.disabled}>{option.name}</option>
          )}
        </select>

        <FieldMessages
          errorMessage={errorMessage}
          infoMessage={infoMessage}
        />
      </div>
    );
  }
}
